import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddSubscriptionRestrictionFormValidation(t: TFunction) {
  return yup.object({
    type: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.typeRequired')),
    restrictionScope: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.restrictionScopeRequired')),
    maxValue: yup.number().required(t('formikValidation.orderNumberRequired')),
  });
}
